module.exports = __webpack_public_path__ + "static/media/chatie_logo_n.27e2215a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/chatie_logo_n.png
// module id = 233
// module chunks = 0